import Vue from 'vue'
import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import VueRouter from 'vue-router'
import { SET_LOGGED_IN, SET_ROUTER_ENTER } from "@/store/mutations.type"
import store from "@/store";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login',
    meta: { 
      requiresAuth: false,
    }
  },  
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/Login.vue'),
    meta: { 
      requiresAuth: false
    }
  }, 
  {
    path: '/microsoft-auth/callback',
    name: 'microsoft-auth/callback',
    component: () => import('../views/Login/MicrosoftLogin.vue'),
    meta: { 
      requiresAuth: false
    }
  }, 
  {
    path: '/reset-password/',
    name: 'resetpassword',
    component: () => import('../views/Login/ResetPassword.vue'),
    meta: { 
      requiresAuth: false
    }
  },  
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard/Dashboard.vue'),  
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,6]
    }
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/Users/Users.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3]
    }  
  }, 
  {
    path: '/ext-users',
    name: 'extusers',
    component: () => import('../views/Users/extUsers.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3]
    }  
  }, 
  {
    path: '/inbox',
    name: 'inbox',
    component: () => import('../views/Inbox/Inbox.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4],
      is_group_user: true,
      has_inbox: true
    }
  },    
  {
    path: '/equipment',
    name: 'equipment',
    component: () => import('../views/Equipments/Equipments.vue'),   
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_equip_db: true
    }
  },  
  {
    path: '/equipment/edit/:id',
    name: 'editequipment',
    component: () => import('../views/Equipments/addeditEquipments.vue'),  
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_equip_db: true
    }
  },  
  {
    path: '/equipment/add',
    name: 'addequipment',
    component: () => import('../views/Equipments/addeditEquipments.vue'),   
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_equip_db: true
    }
  },     
  {
    path: '/modules',
    name: 'modules',
    component: () => import('../views/Modules/Modules.vue'),  
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4]
    } 
  }, 
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Login/Register.vue'),  
    meta: { 
      requiresAuth: false
    } 
  },   
  {
    path: '/groups',
    name: 'groups',
    component: () => import('../views/Groups/Groups.vue'),  
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    } 
  },   
  {
    path: '/groups/edit/:id',
    name: 'editgroups',
    component: () => import('../views/Groups/addeditGroups.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    }
  },  
  {
    path: '/groups/add',
    name: 'addgroups',
    component: () => import('../views/Groups/addeditGroups.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    }  
  },
  {
    path: '/learningmaterial',
    name: 'learningmaterial',
    component: () => import('../views/Documents/Documents.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4]
    }  
  },
  {
    path: '/vouchers',
    name: 'vouchers',
    component: () => import('../views/Vouchers/Vouchers.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    } 
  },
  {
    path: '/tutor-vouchers',
    name: 'tutorvouchers',
    component: () => import('../views/Vouchers/tutorVouchers.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    } 
  },
  {
    path: '/coupons',
    name: 'coupons',
    component: () => import('../views/Vouchers/Coupons.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    } 
  },
  {
    path: '/tutor-coupons',
    name: 'tutorcoupons',
    component: () => import('../views/Vouchers/tutorCoupons.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    } 
  },
  {
    path: '/courses',
    name: 'courses',
    component: () => import('../views/Courses/Courses.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4]
    } 
  },
  {
    path: '/drafts',
    name: 'drafts',
    component: () => import('../views/Drafts/Drafts.vue'),   
    meta: { 
      requiresAuth: true,
      allowedUsers:[5] //1
    }
  },
  {
    path: '/draftplayer/:id',
    name: 'draftplayer',
    component: () => import('../views/DraftPlayer/DraftPlayer.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[5] //1
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/Settings/Settings.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,5]
    }  
  },
  {
    path: '/learningmaterial/:id',
    name: 'learningmaterialdetail',
    component: () => import('../views/Documents/DocumentDetail.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,6]
    }  
  },  
  {
    path: '/invoices',
    name: 'invoices',
    component: () => import('../views/Users/Invoices.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,5]
    } 
  }, 
  {
    path: '/forgot-password',
    name: 'forgotpassword',
    component: () => import('../views/Login/ForgotPassword.vue'),
    meta: { 
      requiresAuth: false
    }
  },     
  {
    path: '/users/edit/:id',
    name: 'editusers',
    component: () => import('../views/Users/addeditUsers.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3]
    }  
  },
  {
    path: '/ext-users/edit/:id',
    name: 'editextusers',
    component: () => import('../views/Users/addeditExtUsers.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_external_users: true
    }  
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Users/Profile.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,5,6]
    }  
  },  
  {
    path: '/users/add',
    name: 'addusers',
    component: () => import('../views/Users/addeditUsers.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3]
    }    
  }, 
  {
    path: '/ext-users/add',
    name: 'addextusers',
    component: () => import('../views/Users/addeditExtUsers.vue'), 
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3]
    }    
  },      
  {
    path: '/modules/:id',
    name: 'moduledetails',
    component: () => import('../views/ModuleDetail/ModuleDetail.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4]
    } 
 
  }, 
  {
    path: '/moduleplayer/:id',
    name: 'moduleplayer',
    component: () => import('../views/ModulePlayer/ModulePlayer.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,6]
    }  
  },  
  {
    path: '/pages/:slug',
    name: 'pages',
    component: () => import('../views/Pages/Pages.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3,4,5,6]
    } 
  },  
  {
    path: '/reminder',
    name: 'reminder',
    component: () => import('../views/ReminderEmail/ReminderEmail.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    }  
  },  
  {
    path: '/reminder/add',
    name: 'addreminderemail',
    component: () => import('../views/ReminderEmail/addeditReminderEmail.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    }   
  },   
  {
    path: '/reminder/edit/:id',
    name: 'editreminderemail',
    component: () => import('../views/ReminderEmail/addeditReminderEmail.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    }   
  },   
  {
    path: '/equipment-group',
    name: 'equipmentgroup',
    component: () => import('../views/Equipments/EquipmentGroup/EquipmentGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true
    }  
  },  
  {
    path: '/equipment-group/add',
    name: 'addequipmentgroup',
    component: () => import('../views/Equipments/EquipmentGroup/addeditEquipmentGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true
    } 
  },  
  {
    path: '/equipment-group/edit/:id',
    name: 'editequipmentgroup',
    component: () => import('../views/Equipments/EquipmentGroup/addeditEquipmentGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true
    }  
  }, 
  {
    path: '/equipment-template',
    name: 'Calibrationtemplate',
    component: () => import('../views/Equipments/CalibrationTemplate/CalibrationTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true
    } 
  },  
  {
    path: '/equipment-template/add',
    name: 'addCalibrationtemplate',
    component: () => import('../views/Equipments/CalibrationTemplate/addeditCalibrationTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true
    } 
  },  
  {
    path: '/equipment-template/edit/:id',
    name: 'editCalibrationtemplate',
    component: () => import('../views/Equipments/CalibrationTemplate/addeditCalibrationTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_equip_db: true
    }
  }, 
  {
    path: '/personal-template',
    name: 'personaltemplate',
    component: () => import('../views/Groups/PersonalTemplate/PersonalTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    }
  }, 
  {
    path: '/personal-template/add',
    name: 'addpersonaltemplate',
    component: () => import('../views/Groups/PersonalTemplate/addeditPersonalTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    } 
  }, 
  {
    path: '/personal-template/edit/:id',
    name: 'editpersonaltemplate',
    component: () => import('../views/Groups/PersonalTemplate/addeditPersonalTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    }
  }, 
  {
    path: '/task-center-group',
    name: 'testcasegroup',
    component: () => import('../views/TestCase/TestCaseGroup/TestCaseGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_task_center: true
    }
  }, 
  {
    path: '/task-center-group/add',
    name: 'addtestcasegroup',
    component: () => import('../views/TestCase/TestCaseGroup/addeditTestCaseGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_task_center: true
    }
  }, 
  {
    path: '/task-center-group/edit/:id',
    name: 'edittestcasegroup',
    component: () => import('../views/TestCase/TestCaseGroup/addeditTestCaseGroup.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    }
  }, 
  {
    path: '/task-center-template',
    name: 'testcasetemplate',
    component: () => import('../views/TestCase/TestCaseTemplate/TestCaseTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_task_center: true
    }
  },
  {
    path: '/task-center-template/add',
    name: 'addtestcasetemplate',
    component: () => import('../views/TestCase/TestCaseTemplate/addeditTestCaseTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1]
    } 
  }, 
  {
    path: '/task-center-template/edit/:id',
    name: 'edittestcasetemplate',
    component: () => import('../views/TestCase/TestCaseTemplate/addeditTestCaseTemplate.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1],
      has_task_center: true
    }
  }, 
  {
    path: '/task-center/',
    name: 'testcase',
    component: () => import('../views/TestCase/TestCase.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_task_center: true
    }
  },   
  {
    path: '/task-center/add',
    name: 'testcaseadd',
    component: () => import('../views/TestCase/addeditTestCase.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_task_center: true
    } 
  }, 
  {
    path: '/task-center/edit/:id',
    name: 'testcaseedit',
    component: () => import('../views/TestCase/addeditTestCase.vue'),
    meta: { 
      requiresAuth: true,
      allowedUsers:[1,3],
      has_task_center: true
    }
  },  

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
    if(store.getters.isAuthenticated){
      if (JwtService.getToken()) {
        ApiService.setHeader();
        store.commit(SET_ROUTER_ENTER, true)
        store.commit(SET_LOGGED_IN, true)
      }
    }

    let roleStatus = to.meta.hasOwnProperty('allowedUsers') ? to.meta.allowedUsers.some(o => store.getters.currentUser.roles.includes(o)) : false
    if(!to.meta.requiresAuth)
      next()
    else if(to.meta.requiresAuth && (!store.getters.isAuthenticated || !roleStatus))
      next({ name: 'login' })
    else if (to.meta.hasOwnProperty('has_task_center') && JSON.parse(store.getters.currentUser.company.company_meta).has_task_center == 'false')
      next({ name: 'login' })
    else if (to.meta.hasOwnProperty('has_equip_db') && JSON.parse(store.getters.currentUser.company.company_meta).has_equip_db == 'false')
      next({ name: 'login' })
    else next()    

})



export default router
